import React from 'react';

const Button = ({ children, onClick, type = 'button', disabled = false, ...props }) => {
  const baseStyle = 
    `w-full px-4 py-2 font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 transition-colors duration-300
    ${disabled 
      ? 'bg-gray-300 dark:bg-gray-700 text-gray-500 dark:text-gray-400 cursor-not-allowed'
      : 'bg-blue-600 dark:bg-blue-700 text-white hover:bg-blue-700 dark:hover:bg-blue-600 focus:ring-blue-500'}`;

  return (
    <button
      type={type}
      onClick={onClick}
      className={baseStyle}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;